(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-always-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-product-tab]');
    if (!tab) return;
    const section = tab.closest('.home-product-tabs');
    if (!section) return;
    const selected = tab.dataset.productTab;
    section.querySelectorAll('[data-product-tab]').forEach((button) => {
      const active = button.dataset.productTab === selected;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    section.querySelectorAll('[data-product-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.productPanel !== selected;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["no3-nature-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('no3-mobile-video')) {
  customElements.define('no3-mobile-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.video = this.querySelector('video');
      this.control = this.querySelector('button');
      this.poster = this.querySelector('.no3-mobile-video__poster');
      this.link = this.querySelector('.no3-mobile-video__link');
      this.hero = this.closest('.no3-nature-hero');
      this.heading = this.hero.querySelector('h1');
      this.originalHeading = this.heading.textContent;
      this.price = this.hero.querySelector('.no3-nature-hero__mobile-price');
      this.cta = this.hero.querySelector('.no3-nature-hero__mobile-cta');
      this.ctaLabel = this.cta.querySelector('[data-no3-cta-label]');
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.userPaused = false;
      this.userRequestedPlayback = false;
      this.inView = false;
      this.failed = false;
      this.index = 0;
      try {
        this.playlist = JSON.parse(this.querySelector('[data-no3-video-playlist]').textContent)
          .filter(slide => slide.url && slide.poster && slide.productUrl);
      } catch {
        this.playlist = [];
      }
      if (!this.playlist.length) {
        this.playlist = [{ url: this.dataset.videoUrl, poster: this.poster.src,
          productUrl: this.link.getAttribute('href'), title: this.poster.alt,
          heading: this.originalHeading, linkLabel: this.link.textContent.trim(),
          priceText: this.price.textContent.trim(), cta: this.dataset.cta,
          subscriptionCta: this.dataset.subscriptionCta }];
      }
      this.rotates = this.dataset.rotate === 'true' && this.playlist.length > 1;
      this.video.loop = !this.rotates;
      this.setControl = () => {
        const playing = !this.video.paused;
        this.control.dataset.paused = String(!playing);
        this.control.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      };
      this.setCta = () => {
        const slide = this.playlist[this.index];
        const value = this.video.currentTime >= 16 ? slide.subscriptionCta : slide.cta;
        if (this.ctaLabel.textContent !== value) this.ctaLabel.textContent = value;
      };
      this.canPlay = () => this.mobile.matches && this.inView && !document.hidden &&
        !this.userPaused && !this.failed && (this.userRequestedPlayback ||
        (!this.reduced.matches && !navigator.connection?.saveData));
      this.applySlide = (index, loadVideo = false) => {
        this.index = index;
        const slide = this.playlist[index];
        this.dataset.activeProduct = slide.productUrl;
        this.dataset.activeIndex = String(index);
        this.dataset.videoUrl = slide.url;
        this.link.setAttribute('href', slide.productUrl);
        this.link.querySelector('span').textContent = slide.linkLabel;
        this.cta.setAttribute('href', slide.productUrl);
        this.ctaLabel.textContent = slide.cta;
        this.price.textContent = slide.priceText;
        this.poster.alt = slide.title;
        if (this.mobile.matches) this.heading.textContent = slide.heading;
        if (loadVideo) {
          this.video.pause();
          this.classList.remove('is-playing');
          this.poster.removeAttribute('srcset');
          this.poster.src = slide.poster;
          this.video.src = slide.url;
          this.failed = false;
          this.setControl();
          this.playVideo();
        }
      };
      this.playVideo = () => {
        if (!this.canPlay()) return;
        this.video.muted = true;
        if (!this.video.getAttribute('src')) this.video.src = this.playlist[this.index].url;
        this.video.play().catch(() => this.setControl());
      };
      this.onClick = event => {
        event.stopPropagation();
        if (this.video.paused) {
          this.userPaused = false;
          this.userRequestedPlayback = true;
          if (this.failed) { this.failed = false; this.video.load(); }
          this.playVideo();
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };
      this.onPlaying = () => { this.classList.add('is-playing'); this.setControl(); };
      this.onError = () => {
        this.failed = true;
        this.video.pause();
        this.classList.remove('is-playing');
        this.setControl();
      };
      this.onEnded = () => {
        if (this.rotates && this.canPlay()) this.applySlide((this.index + 1) % this.playlist.length, true);
      };
      this.onVisibility = () => {
        if (document.hidden) this.video.pause();
        else this.playVideo();
      };
      this.onViewport = () => {
        this.control.hidden = !this.mobile.matches;
        this.heading.textContent = this.mobile.matches ? this.playlist[this.index].heading : this.originalHeading;
        if (!this.canPlay()) this.video.pause();
        else this.playVideo();
      };
      this.control.addEventListener('click', this.onClick);
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('pause', this.setControl);
      this.video.addEventListener('error', this.onError);
      this.video.addEventListener('timeupdate', this.setCta);
      this.video.addEventListener('ended', this.onEnded);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.mobile.addEventListener('change', this.onViewport);
      this.reduced.addEventListener('change', this.onViewport);
      this.control.hidden = !this.mobile.matches;
      this.applySlide(0);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (!this.inView) this.video.pause();
        else this.playVideo();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.video.pause();
      this.observer.disconnect();
      this.control.removeEventListener('click', this.onClick);
      this.video.removeEventListener('playing', this.onPlaying);
      this.video.removeEventListener('pause', this.setControl);
      this.video.removeEventListener('error', this.onError);
      this.video.removeEventListener('timeupdate', this.setCta);
      this.video.removeEventListener('ended', this.onEnded);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.mobile.removeEventListener('change', this.onViewport);
      this.reduced.removeEventListener('change', this.onViewport);
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('no3-sticky-purchase')) {
    customElements.define('no3-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = document.querySelector('[id^="MainProduct-"]');
        if (!this.root) return;
        this.buy = this.querySelector('.no3-sticky-buy');
        this.edit = this.querySelector('.no3-sticky-edit');
        this.refresh = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        };
        this.onBuy = () => {
          this.sync();
          const button = this.mainButton();
          if (!button || this.buy.disabled) return;
          this.pending = true;
          this.buy.disabled = true;
          button.click();
          this.release = setTimeout(() => { this.pending = false; this.refresh(); }, 1200);
        };
        this.onEdit = () => {
          const button = this.mainButton();
          const target = button?.closest('product-form') || button;
          target?.scrollIntoView({behavior: 'smooth', block: 'center'});
          const choice = target?.querySelector('input[type="radio"]:checked,select');
          (choice || button)?.focus({preventScroll: true});
        };
        this.buy.addEventListener('click', this.onBuy);
        this.edit.addEventListener('click', this.onEdit);
        this.root.addEventListener('change', this.refresh);
        this.root.addEventListener('input', this.refresh);
        window.addEventListener('scroll', this.refresh, {passive: true});
        window.addEventListener('resize', this.refresh);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this.root, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class','style','value','checked']});
        const drawer = document.querySelector('cart-drawer');
        if (drawer) this.observer.observe(drawer, {attributes: true, attributeFilter: ['class']});
        this.observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
        this.sync();
      }
      mainButton() { return this.root?.querySelector('product-form button[name="add"]'); }
      visible(el) { return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden'; }
      sync() {
        const button = this.mainButton();
        if (!button) { this.hidden = true; return; }
        const form = button.closest('form');
        const summaryElement = form?.querySelector('no3-purchase-summary');
        const summary = summaryElement && !summaryElement.hidden ? summaryElement : null;
        const summaryPrice = summary?.querySelector('.no3-purchase-summary__price')?.textContent.trim();
        const summaryPlan = summary?.querySelector('.no3-purchase-summary__plan')?.textContent.trim();
        const priceRoot = this.root.querySelector('[id^="price-"]');
        const prices = Array.from(priceRoot?.querySelectorAll('.price-item') || []);
        const price = prices.find(el => this.visible(el) && !el.closest('s') && !getComputedStyle(el).textDecorationLine.includes('line-through') && el.textContent.trim());
        const selectedPlan = form?.querySelector('input[name="selling_plan"]:checked,select[name="selling_plan"],input[type="hidden"][name="selling_plan"]');
        const planSelect = form?.querySelector('select.appstle_select');
        const plan = selectedPlan?.value ? (planSelect?.selectedOptions[0]?.textContent || form?.querySelector('input[name="selling_plan"]:checked')?.getAttribute('aria-label') || '') : this.dataset.oneTime;
        const quantity = Array.from(form?.elements || []).find(el => el.name === 'quantity')?.value || '1';
        this.querySelector('.no3-sticky-price').textContent = summaryPrice || price?.textContent.trim() || '';
        this.querySelector('.no3-sticky-plan').textContent = [summaryPlan || plan, quantity !== '1' ? `${this.dataset.quantityLabel}: ${quantity}` : ''].filter(Boolean).join(' · ');
        this.buy.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
        this.buy.disabled = this.pending || button.disabled || button.getAttribute('aria-disabled') === 'true';
        const error = this.root.querySelector('.product-form__error-message-wrapper:not([hidden])');
        const blocked = document.querySelector('cart-drawer.active, dialog[open], .search-modal[open]') || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('cart-drawer-quick-view');
        this.hidden = (summaryElement ? !summaryPrice : !price) || button.getBoundingClientRect().bottom >= 0 || !!blocked;
        if (error && this.visible(error) && error.textContent.trim() && this.pending) {
          error.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.release);
        window.removeEventListener('scroll', this.refresh);
        window.removeEventListener('resize', this.refresh);
        this.root?.removeEventListener('change', this.refresh);
        this.root?.removeEventListener('input', this.refresh);
        this.buy?.removeEventListener('click', this.onBuy);
        this.edit?.removeEventListener('click', this.onEdit);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
